import { Datepicker } from 'components/form/Datepicker';
import { DateRangePicker } from 'components/form/DateRangePicker';
import { FormCheckbox } from 'components/form/formCheckbox/FormCheckbox';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { ListBoxModal } from 'components/modals/ListBoxModal';
import { Toaster } from 'components/notification/Toaster';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { isArrayNotEmpty, isDateValid, isNotNullUndefined } from 'functions';
import { useCustomSelector } from 'hooks';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

function useUpdateReportingData(props) {
    const [isInvoiceTypeSelected, setIsInvoiceTypeSelected] = useState();
    const [isCreditNoteTypeSelected, setIsCreditNoteTypeSelected] = useState();
    const [selectedDate, setSelectedDate] = useState();

    const [isModalVisible, setIsModalVisible] = useState();
    const { 
        updateInvoiceReportingData_requesting, updateInvoiceReportingData_isSuccessful,
        updateCreditNoteReportingData_requesting, updateCreditNoteReportingData_isSuccessful
    } = useCustomSelector("reporting");
    const { updateInvoiceReportingData, updateCreditNoteReportingData } = useReporting();

    // Reset
    useEffect(() => {
        if (!isModalVisible) {
            setIsCreditNoteTypeSelected(false);
            setIsInvoiceTypeSelected(false);
            setSelectedDate("");
        }
    }, [isModalVisible]);

    let updateReportingDataModal = (
        <ListBoxModal
            className={"dashboardSidebar__update-reporting-modal"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}

            title={"Update Database"}

            header={"Reporting Type"}

            topContent={(
                <>
                    {/* Title */}
                    <div className={"update-reporting-modal__title"}>Update Sales Person Commission Report Data from SQL Accounting System into Database</div>

                    {/* Date */}
                    <Datepicker
                        className={"update-reporting-modal__date"}
                        placeholder={"Select Date"}
                        label={"Date"}
                        handleOnChange={setSelectedDate}
                        isResetRequired={!isModalVisible}
                        dateFormat={"MM/yyyy"}
                        isMonthYear
                    />
                </>
            )}
            labelList={["Invoice", "Credit Note"]}
            list={["invoice", "creditNote"]}
            listBoxOptions={{
                className: "update-reporting-modal__list-box flex-fill",
                listBodyClassName: "list-box__input"
            }}

            actionTxt={"Update"}
            handleOnConfirm={(list) => {
                if (isDateValid(selectedDate)) {
                    if (isArrayNotEmpty(list)) {
                        let isUpdateDone = false;
                        list.map((type) => {
                            switch(type) {
                                case "invoice": 
                                    updateInvoiceReportingData(selectedDate);
                                    isUpdateDone = true;
                                    break;
                                case "creditNote":
                                    updateCreditNoteReportingData(selectedDate);
                                    isUpdateDone = true;
                                    break;
                                default:
                                    Toaster({
                                        type: "error",
                                        msg: "Reporting type is required"
                                    })
                            }
                        })

                        if (isUpdateDone) setIsModalVisible(false);
                    }
                }
                else {
                    Toaster({
                        type: "error",
                        msg: "Date is required"
                    })
                }

            }}

            otherProps={{
                isCancelButtonVisible: true,
                cancelButtonText: "Cancel",
                footerCancelClassName: "update-reporting-modal__cancel"
            }}
        />
    );

    // let updateReportingDataModal = (
    //     <ConfirmationModal
    //         isModalVisible={isModalVisible}
    //         updateParentState={setIsModalVisible}

    //         className={"dashboardSidebar__update-reporting-modal"}
    //         headerClassName={"update-reporting-modal__header"}

    //         description={"Update reporting data from SQL Accounting System into Database."}
    //         input={(
    //             <>
    //                 {/* Date */}
    //                 <Datepicker
    //                     className={"update-reporting-modal__date"}
    //                     placeholder={"Select Date"}
    //                     handleOnChange={(date) => {
    //                         setSelectedDate(moment(date).format("YYYY-MM-DD"))
    //                     }}
    //                     isResetRequired={!isModalVisible}
    //                     isMonthYear
    //                 />

    //                 {/* Reporting Type */}
    //                 <div className={"update-reporting-modal__reporting-type"}>
    //                     {/* Label */}
    //                     <div className={"reporting-type__label"}>
    //                         Reporting Type:
    //                     </div>

    //                     {/* Invoice */}
    //                     <FormCheckbox
    //                         className={"reporting-type__invoice"}
    //                         checkboxClassName={"invoice__checkbox"}
    //                         labelClassName={"invoice__label"}

    //                         checkboxLabel={"Invoice"}
    //                         handleCheckboxSelectionSub={(checkboxId, isChecked) => {
    //                             setIsInvoiceTypeSelected(isChecked);
    //                         }}
    //                         isResetRequired={!isModalVisible}
    //                         isDecoration_lightBackground
    //                     />

    //                     {/* Credit Note */}
    //                     <FormCheckbox
    //                         className={"reporting-type__credit-note"}
    //                         checkboxClassName={"credit-note__checkbox"}
    //                         labelClassName={"credit-note__label"}

    //                         checkboxLabel={"Credit Note"}
    //                         handleCheckboxSelectionSub={(checkboxId, isChecked) => {
    //                             setIsCreditNoteTypeSelected(isChecked);
    //                         }}
    //                         isResetRequired={!isModalVisible}
    //                         isDecoration_lightBackground
    //                     />
    //                 </div>
    //             </>
    //         )}

    //         cancelButtonText={"Cancel"}
    //         confirmButtonText={"Update"}
    //         handleOnConfirm={() => {
    //             if (isDateValid(selectedDate)) {
    //                 if (isInvoiceTypeSelected || isCreditNoteTypeSelected) {
    //                     if (isInvoiceTypeSelected) updateInvoiceReportingData(selectedDate);
    //                     if (isCreditNoteTypeSelected) updateCreditNoteReportingData(selectedDate);
    //                 }
    //                 else {
    //                     Toaster({
    //                         type: "error",
    //                         msg: "Reporting type is required"
    //                     })
    //                 }
    //             }
    //             else {
    //                 Toaster({
    //                     type: "error",
    //                     msg: "Date is required"
    //                 })
    //             }
    //         }}
    //         isActionLoading={
    //             isInvoiceTypeSelected && isCreditNoteTypeSelected?
    //             updateInvoiceReportingData_requesting && updateCreditNoteReportingData_requesting:
    //                 isInvoiceTypeSelected?
    //                 updateInvoiceReportingData_requesting: 
    //                 updateCreditNoteReportingData_requesting
    //         }
    //         isConfirmSuccessful={
    //             isInvoiceTypeSelected && isCreditNoteTypeSelected?
    //             updateInvoiceReportingData_isSuccessful && updateCreditNoteReportingData_isSuccessful:
    //                 isInvoiceTypeSelected?
    //                 updateInvoiceReportingData_isSuccessful: 
    //                 updateCreditNoteReportingData_isSuccessful
    //         }
    //     />
    // );
    
    return {
        updateReportingDataModal,
        setIsModalVisible
    }
}

export default useUpdateReportingData;